import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import themeBackground from './img/background.jpg'

const Intro = ({
  coupleData: { coupleFirstName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram'
      : 'vão se casar'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro318">
      <div className="animated-intro-small screen">
        <img
          className="background-4QFuFN"
          src={background || themeBackground}
        />
        <div
          className="site-de-casamento-e-4QFuFN"
          dangerouslySetInnerHTML={{ __html: warningMessage }}
        />
        <button className="button-4QFuFN" onClick={onSkipIntro}>
          <div className="pular-introduo-YrZHDo">{buttonMessage}</div>
        </button>
        <div className="couple-name-4QFuFN">
          <div className="mariana-e-eduardo-DINxli lg---title-md bp1-animate-enter">
            {coupleFirstName.bride}
            {coupleFirstName.groom && <> e {coupleFirstName.groom}</>}
          </div>
          <div className="vo-se-casar-DINxli bp1-animate-enter1">{text}</div>
        </div>
      </div>
      <div className="animated-intro-large screen">
        <img
          className="background-p4EdWL"
          src={background || themeBackground}
        />
        <div className="button-p4EdWL">
          <div
            className="site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <button className="button-CpwLjN" onClick={onSkipIntro}>
            <div className="pular-introduo-fo8x79">{buttonMessage}</div>
          </button>
        </div>
        <div className="couple-name-p4EdWL">
          <div className="mariana-e-eduardo-VF7rnS lg---title-xl bp2-animate-enter">
            {coupleFirstName.bride}
            {coupleFirstName.groom && <> e {coupleFirstName.groom}</>}
          </div>
          <div className="vo-se-casar-VF7rnS bp2-animate-enter1">{text}</div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
